<p
  class="gpb-8 gmb-0"
  [class.h4-bold]="!smallTitle"
  [class.h7-bold]="smallTitle"
>
  {{ question.name }}
</p>

<p *ngIf="question.hint" class="p4-regular text-mute gmb-0">
  {{ question.hint }}
</p>

<app-examples-modal-buttons [question]="question" />

<div class="gpt-16 gpt-sm-32">
  <ng-template questionnaireHost></ng-template>
</div>
